<template>
  <div class="calendar">
    <div v-if="isOverdue" class="overdue-container">
      <div class="overdue-message">Your assignment is overdue.</div>
      <div class="overdue-more">
        You can still turn in your review at any time, and
        the author would greatly appreciate it! Thank you!
      </div>
    </div>
    <template v-else>
      <day
        v-for="day in days"
        :day="day"
        :dueDate="dueDate"
        :due="formatDate(day) === formatDate(dueDate)"
      ></day>
    </template>
  </div>
</template>

<script>
import Day from "./CalendarDay";

export default {
  name: "Calendar",
  props: ["dueDate"],
  components: { Day },
  data: function() {
    return {
      days: null,
      isOverdue: false
    };
  },
  created() {
    let days = [];

    const today = new Date();
    const dueDate = this.dueDate;
    const inbetween = Math.round((dueDate - today) / (1000 * 60 * 60 * 24));

    if (today > dueDate) {
      this.isOverdue = true;
    }

    days.push(today);
    const thisDate = new Date();
    for (let d = 0; d < inbetween - 1; d++) {
      thisDate.setTime(thisDate.getTime() + 3600 * 24 * 1000);
      const newDate = new Date(thisDate.getTime());
      days.push(newDate);
    }

    if (formatDate(today) !== formatDate(dueDate)) {
      days.push(dueDate);
    }

    this.days = days;
    this.dueDate = dueDate;
  },
  methods: {
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return date.toLocaleDateString("en-US", options);
    }
  }
};

function formatDate(date) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
}
</script>

<style lang="scss" scoped>
.calendar {
  display: flex;
  justify-content: left;
  margin-top: 2px;
  zoom: 1.05;
}

.overdue-container {
  display: block;
  padding: 8px 16px 24px 16px;
  font-family: $font-family;
}

.overdue-message {
  padding-bottom: 2px;
  font-size: 13.5pt;
  color: $color-snaps;
  font-weight: 600;
}

.overdue-more {
  max-width: 460px;
  font-size: 12pt;
  color: #111;
  font-weight: 500;
}
</style>


